import { AuthCodeFromEmailFailure, AuthCodeFromEmailRequest, AuthCodeFromEmailResponse } from '@/types/auth-code';
import { Post, Get } from './helpers';
import { Channel } from '@/types/channel';

export const AuthCodeFromEmail = async (
  body: AuthCodeFromEmailRequest
): Promise<AuthCodeFromEmailResponse | AuthCodeFromEmailFailure> => {
  return Post<AuthCodeFromEmailResponse | AuthCodeFromEmailFailure>({ url: `/v3/admin/auth/auth-code`, body });
};

export function GetChannelsFromStoredSession(stored_token: string): Promise<Channel[]> {
  return Get<Channel[]>({
    url: `/v3/admin/auth/available-channels`,
    headers: { Authorization: `Bearer ${stored_token}` },
  });
}

export function requestEmailAuthCode(email: string): Promise<{ temp_profile: string }> {
  const params = new URLSearchParams({ email });
  return Get<{ temp_profile: string }>({ url: `/v3/admin/auth/auth-code?${params.toString()}` });
}

export const authCode = async (
  temp_profile: string,
  code: string,
  should_confirm: boolean,
  request_storage: boolean
): Promise<{ token: string; storage_token: string | null }> => {
  return Post({
    url: '/v3/admin/auth/confirm-code',
    body: { temp_profile, code, should_confirm, request_storage },
  });
};
